// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__pf-86","info":"Note_info__16ygo","note":"Note_note__1UPf1","actions":"Note_actions__E3OV_"};